import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = ({ currentLanguage }) => {
  const translations = {
    EN: {
      gdpr: 'GDPR Compliant',
      hipaa: 'HIPAA Certified',
      iso: 'ISO 27001',
      encryption: '256-bit Encryption',
    },
    FR: {
      gdpr: 'Conforme RGPD',
      hipaa: 'Certifié HIPAA',
      iso: 'ISO 27001',
      encryption: 'Chiffrement 256 bits',
    },
  };

  const t = translations?.[currentLanguage];

  const badges = [
    { icon: 'Shield', label: t?.gdpr },
    { icon: 'ShieldCheck', label: t?.hipaa },
    { icon: 'Award', label: t?.iso },
    { icon: 'Lock', label: t?.encryption },
  ];

  return (
    <div className="flex flex-wrap items-center justify-center gap-6 mt-8">
      {badges?.map((badge, index) => (
        <div
          key={index}
          className="flex items-center gap-2 text-muted-foreground"
        >
          <Icon name={badge?.icon} size={16} />
          <span className="text-xs font-medium">{badge?.label}</span>
        </div>
      ))}
    </div>
  );
};

export default SecurityBadges;